import React, { useState } from 'react';

import {DivAccordion, StyledTbody, DivAccordionMobile} from './styles';

import {Switch} from 'antd';
import Collapse from "@kunukn/react-collapse";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {FiChevronDown, FiMinus, FiPlus, FiGrid, FiList} from 'react-icons/fi';
import {CgTrash} from 'react-icons/cg';
import {MdReorder, MdMoreVert} from 'react-icons/md';

export function RenderItens({
    type,
    itens,
    setExib,
    tipo_exib,
    nome,
    controllerModalApagar,
    modalApagar,
    editarItem,
    handleOnDrag,
    windowWidth,
    handleAtivo,
    isSuperUser,
    permission
}) {
    const [isOpen, setOpen] = useState(true);

    if (!!itens) {
        return (
            <>
            <h5>Modo de exibição dos itens</h5>
            <div className="modos">
                <div className="card"
                    onClick={() => setExib(0)}>
                    <FiGrid 
                        color={type ? '#a49b9b' : '#000000'}
                        size={16}/>
                    <h4 style={type ? {color: "#a49b9b"} : {color: "#000000"}}>Card</h4>
                </div>
                <div className="lista"
                    onClick={() => setExib(1)}>
                    <FiList 
                        color={!type ? '#a49b9b' : '#000000'}
                        size={16}/>
                    <h4 style={!type ? {color: "#a49b9b"} : {color: "#000000"}}>Lista</h4>
                </div>
            </div>
            <DivAccordion 
                open={isOpen}
                onClick={() => setOpen(!isOpen)}>
                <h4>{!nome.length ? 'Seu grupo' : nome}</h4>
                <div className="icon">
                    <FiChevronDown color={'#000000'} size={20} className="chevron"/>
                </div>
            </DivAccordion>
            <Collapse transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} style={{paddingBottom: '4rem'}} isOpen={isOpen}>
            {type === 0 ? (
                    <>
                    <div className="itens">{
                        <>
                    {itens
                    .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                    .map((item, index) => (
                            <div className="item" key={item.id}>
                                <div className="foto">
                                    <img 
                                        src={item.imagem !== null ? `https://appedidos-share-private.s3.amazonaws.com/${item.imagem}` : null} 
                                        alt="" className="prodImg"/>
                                </div>
                                <div className="texto" onClick={() => editarItem(item)}>
                                    <div>
                                        <span className="title">
                                            Nome
                                        </span>
                                        <span>{item.nome}</span>
                                    </div>
                                    <div>
                                        <span className="title">
                                            Preço
                                        </span>
                                        <span>{`R$ ${(item.valor).replace(".", ",")}`}</span>
                                    </div>
                                </div>
                                <button 
                                    onClick={() => controllerModalApagar(modalApagar, item)}>
                                    <CgTrash color="#a09c9b" className="i-close" />
                                </button>
                            </div>
                    ))}
                        </>
                    }</div>
                    </>
            ) : ( 
                <DragDropContext onDragEnd={handleOnDrag}>
                <Droppable droppableId="items">
                {(provided) => (
                    windowWidth > 690 ? (
                    <table 
                    {...provided.droppableProps} 
                    ref={provided.innerRef}>
                        <thead>
                            <tr>
                                <th />
                                <th>Foto</th>
                                <th className="th-nome">Nome</th>
                                <th className="th-valor">Valor</th>
                                <th/>
                            </tr>
                        </thead>
                    {itens
                    .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                    .map((item, index) => (
                        <Draggable
                            key={item.id}
                            style={(_isDragging, draggableStyle) => ({ ...draggableStyle, position: 'static' })}
                            draggableId={String(item.id)}
                            index={index}>
                        {(provided, snapshot) => (
                            <>
                            <StyledTbody
                            isDragging={snapshot.isDragging}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}>
                                <tr>
                                    <td className="td-drag" style={{cursor: "grab"}}>
                                    <MdReorder 
                                        className="icon"/>
                                    </td>
                                    <td>
                                        <img 
                                        src={item.imagem !== null ? `https://appedidos-share-private.s3.amazonaws.com/${item.imagem}` : null} 
                                        alt="" className="prodImg"/>
                                    </td>
                                    <td className="td-nome" onClick={() => editarItem(item)}><span>{item.nome}</span></td>
                                    <td className="td-valor" onClick={() => editarItem(item)}>{`R$ ${(item.valor).replace(".", ",")}`}</td>
                                    <td className="td-switch">
                                        <div>
                                        <label className="switch">
                                            <Switch
                                                onChange={
                                                    () => isSuperUser ? 
                                                    permission === 2 ? handleAtivo(item.id, !item.ativo) : null 
                                                    : handleAtivo(item.id, !item.ativo)
                                                }
                                                defaultChecked={item.ativo}
                                                checked={item.ativo}
                                            />
                                            <h4>{item.ativo ? 'Ativo' : 'Inativo'}</h4>
                                        </label>
                                        <button 
                                            className="button-del"
                                            onClick={() => controllerModalApagar(modalApagar, item)}>
                                            <CgTrash color="#a09c9b" className="i-close" />  
                                        </button>
                                        </div>
                                    </td>
                                </tr>
                            </StyledTbody>
                            </>
                        )}
                        </Draggable>
                    ))}
                    {provided.placeholder}
                    </table>
                    ) : (
                        <div {...provided.droppableProps} 
                            ref={provided.innerRef}>
                            {itens
                                .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                .map((item, index)=> (
                                    <RenderListMobile 
                                        key={item.id} 
                                        prod={item} 
                                        index={index} 
                                        handleAtivo={(id, ativo) => handleAtivo(id, ativo)}
                                        isSuperUser={isSuperUser}
                                        permission={permission}
                                        editarItem={(prod) => editarItem(prod)}
                                        modalApagar={modalApagar}
                                        controllerModalApagar={(state, prod) => controllerModalApagar(state, prod)}
                                    />
                            ))}
                            {provided.placeholder}
                        </div>
                    )
                )}
                </Droppable>
                </DragDropContext>
            )}
            </Collapse>
            </>
        )
    } else {
        return <h5>Você não cadastrou nenhum item nesse grupo.</h5>
    }
}

export function RenderListMobile({ 
    prod, 
    index,
    handleAtivo,
    isSuperUser,
    permission,
    editarItem,
    controllerModalApagar,
    modalApagar
}) {
    const [isOpen, setOpen] = useState(false);

    return (
        <>
        <Draggable
            draggableId={String(prod.id)}
            index={index}>
        {(provided, snapshot) => (
            <DivAccordionMobile
                    isDragging={snapshot.isDragging}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={provided.innerRef}
                open={isOpen}>
                    <div className="header-collapse">
                        <div className="left">
                            <div className="reorder">
                                <MdReorder 
                                className="icon-reorder"/>
                            </div>

                            <div
                                style={{width: 48, height: 48}}>
                                <img 
                                    style={{width: 48, height: 48}}
                                    className={prod.ativo ? "prod-img" : "prod-img-gray"}
                                    src={prod.imagem !== null && !!prod.imagem.length ? `https://appedidos-share-private.s3.amazonaws.com/${prod.imagem}` : null} 
                                    alt="Imagem" />
                            </div>

                            <div className="texts">
                                <span className="title">Nome</span>
                                <span className="content">{prod.nome}</span>
                            </div>
                        </div>

                        <div className="right">
                            <div className="icon" onClick={() => setOpen(!isOpen)}>
                                <FiChevronDown color={"#a49b9b"} size={20} className="chevron"/>
                            </div>
                        </div>
                    </div>
                <Collapse 
                    transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} 
                    isOpen={isOpen}>
                    <div className="collapsed-div">
                        <div 
                            className="texts" 
                            style={{ marginTop: 32, marginBottom: 32, marginLeft: 98 }}>
                            <span className="title">Valor</span>
                            <span className="content">{`R$ ${(prod.valor).replace(".", ",")}`}</span>
                        </div>
                        <div
                            style={{ marginBottom: 32, marginLeft: 98 }} 
                            className="texts-switch">
                            <span className="title">Situação</span>
                            <label className="switch-mobile">
                                <Switch
                                    onChange={
                                        () => isSuperUser ? 
                                        permission === 2 ? handleAtivo(prod.id, !prod.ativo) : null 
                                        : handleAtivo(prod.id, !prod.ativo)
                                    }
                                    defaultChecked={prod.ativo}
                                    checked={prod.ativo}
                                />
                                <h4>{prod.ativo ? 'Ativo' : 'Inativo'}</h4>
                            </label>
                        </div>

                        <div className="buttons">
                            <button
                                onClick={() => editarItem(prod)} 
                                className="red">
                                Ver mais
                            </button>
                            <button 
                                onClick={() => controllerModalApagar(modalApagar, prod)}
                                className="white">
                                Excluir adicional
                            </button>
                        </div>
                    </div>
                </Collapse>
            </DivAccordionMobile>
                )}
            </Draggable>
            </>
    )
};